import { NotifyHelper } from "../../../helpers/toast";
import { objLoaiGiayToDefine } from "../../action-types/loai-giay-to/ILoaiGiayToActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const loaiGiayToAction = {
    ...generateActions(objLoaiGiayToDefine, "LOAI_GIAY_TO"),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "LOAD_SELECT_VIEW_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "LOAD_SELECT_VIEW_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "LOAD_SELECT_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "LOAD_SELECT_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "UPDATE_SUCCESS", (m: any) => NotifyHelper.Success("Updated")),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "UPDATE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "DELETE_SUCCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objLoaiGiayToDefine, "LOAI_GIAY_TO",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}